import React from 'react';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {
    const pathFrontEnd = '/psp-documenttypes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}psp/documenttypes/delete`,
        endpoint: `${config.endpoints.backend}psp/documenttypes/getall`
    };

    let list = {
        labelTitle: 'Lista de Tipos de Documentos',
        labelTitleButtonAdd: 'Incluir novo Tipo de Documento',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Nome',
                sortable: true
            },
            {
                name: 'allowed_formats',
                label: 'Formatos Permitidos',
                sortable: false,
                cell: (row) => {
                    let formats = row.allowed_formats;
                    if (typeof formats === 'string') {
                        try {
                            formats = JSON.parse(formats);
                        } catch (e) {
                            return formats;
                        }
                    }
                    if (Array.isArray(formats)) {
                        return formats
                            .map(f => {
                                const val = typeof f === 'object' && f !== null ? (f.value || f.label || '') : String(f || '');
                                return val.toUpperCase();
                            })
                            .filter(Boolean)
                            .join(', ');
                    }
                    return '';
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
